module.exports = __webpack_public_path__ + "img/Menu-06.3037366b.png";